import SlotCounter from 'react-slot-counter';
import T from 'i18n-react';

import texts from 'Components/texts.json';

import styles from './VehicleCardBidCount.module.scss';

type VehicleCardBidCountProps = {
	bidCount: number;
};

T.setTexts(texts);

const BID_COUNT_ANIMATION_TIME_IN_S = 0.3;

const VehicleCardBidCount: React.FC<VehicleCardBidCountProps> = ({ bidCount }) => {
	return (
		<div className={styles.bidCountText}>
			<SlotCounter
				autoAnimationStart={false}
				duration={BID_COUNT_ANIMATION_TIME_IN_S}
				sequentialAnimationMode={true}
				value={bidCount}
			/>
			<span>Total bids</span>
		</div>
	);
};

export default VehicleCardBidCount;
